import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import formatError from "../../services/FormatError";
import { sortList } from "./Users";
import { getStatusBadge } from "./Business";
import AddOfferPopup from "./AddOfferPopup";
import swal from "sweetalert";

import {
  acceptOffer,
  fetchAllOffers,
  fetchOfferDetails,
  fetchOffersReceived,
  fetchOffersSent,
  rejectOffer,
  offersPerBusiness,
  deleteOffer,
} from "../../services/Offers";
import { useTranslation } from "react-i18next";

function Offers() {
  const { t } = useTranslation();

  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const navigate = useNavigate();

  const businessId = useLocation()?.state;

  const state = useSelector((state) => state.auth.auth.result);

  const [offersData, setOffersData] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [viewOffer, setViewOffer] = useState({
    cond: false,
    data: {},
  });
  console.log(viewOffer);
  const [updateOffer, setUpdateOffer] = useState({
    cond: false,
    id: null,
    offerId: null,
    view: false,
  });

  useEffect(() => {
    if (businessId === null) {
      getAllOffers();
    } else {
      getOfferPerBusiness();
    }
  }, [businessId, state, tableParams.current, tableParams.pageSize]);

  const getAllOffers = () => {
    if (ctxObj?.loggedinprofiletype === "buyerprofile") {
      fetchOffersSent(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const responseData = response?.data ? sortList(response?.data) : [];

          setOffersData({
            original: responseData,
            filtered: responseData,
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else if (ctxObj?.loggedinprofiletype === "sellerprofile") {
      fetchOffersReceived(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const responseData = response?.data ? sortList(response?.data) : [];

          setOffersData({
            original: responseData,
            filtered: responseData,
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else if (ctxObj?.role?.id === 1 || ctxObj?.role?.id === 2) {
      fetchAllOffers(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const responseData = response?.data ? sortList(response?.data) : [];

          setOffersData({
            original: responseData,
            filtered: responseData,
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  const getOfferPerBusiness = () => {
    offersPerBusiness(businessId, tableParams.current, tableParams.pageSize)
      .then((res) => {
        const response = res.data?.result;

        const responseData = response?.data ? sortList(response?.data) : [];

        setOffersData({
          original: responseData,
          filtered: responseData,
        });

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.count,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = offersData.original.filter((item) =>
        item?.business?.name.toLowerCase().includes(value.toLowerCase())
      );

      setOffersData((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setOffersData((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onViewBuyer = (id) => {
    fetchOfferDetails(id)
      .then((res) => {
        const response = res?.data?.result;

        setViewOffer({
          cond: true,
          data: response,
        });
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onUpdateBuyer = (businessId, id) => {
    setUpdateOffer({
      cond: true,
      id: businessId,
      offerId: id,
      view: true,
    });
  };

  const onDeleteBuyer = (id) => {
     swal({
      title: t("hdelete"),
      text: t("hconfirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willdelete) => {
      if(willdelete){
        deleteOffer(id)
          .then((res) => {
            getAllOffers();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
        }
      });
  };

  const onBack = () => {
    setViewOffer({
      cond: false,
      data: {},
    });
  };

  const onAcceptOffer = () => {
     swal({
      title: t("hconfirm"),
      text: t("hacceptoffreconfirm"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willaccept) => {
      if(willaccept){
          acceptOffer(viewOffer.data.id)
          .then((res)=>{
            swal(("Offre acceptée"),{
               icon: "success",
            });

            onBack()
            getAllOffers();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
        }
      })
      
  };

  const onRejectOffer = () => {
     swal({
      title: "",
      text: t("hrejectoffreconfirm"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willreject) => {
      if(willreject){
        rejectOffer(viewOffer.data.id)
          .then((res) => {
            onBack();
            getAllOffers();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
        }
      })
  };

  const onCreateContract = (id) => {
    navigate("/contracts", { state: id });
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t("hbusinessName")}`,
      dataIndex: "business",
      sorter: true,
      render: (obj, record) => {
        return (
          <>
            <span>{obj?.name}</span>
            <br />
            <span>{record?.currency?.name}</span>
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("currencyInput")}`,
      dataIndex: "currency",
      width: "20%",
      render: (obj, record) => {
        return (
          <>
            <span>{record?.currency?.code}</span>
          </>
        );
      },
    },
    {
      title: `${t("businessEquityOffered")}`,
      dataIndex: "equityoffered",
      width: "20%",
      render: (obj, record) => {
        return (
          <>
            <span>{record?.equityoffered}%</span>
          </>
        );
      },
    },
    {
      title: `${t("userCollumn6")}`,
      dataIndex: "status",
      width: "20%",
    },
    {
      title: `${t("hprice")}`,
      dataIndex: "price",
      width: "20%",
      render: (obj, record) => {
        return (
          <>
            <span>{record?.currency?.symbol}{record?.price}</span>
          </>
        );
      },
    },
    {
      title: `${t("buyerProfileCulumn7")}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewBuyer(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </a>
            {ctxObj?.loggedinprofiletype === "buyerprofile" &&
              record?.status !== "accepted" && (
                <>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-info btn-xs light px-2"
                    onClick={() =>
                      onUpdateBuyer(record?.business?.id, record?.id)
                    }
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                        stroke="#fff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="ms-2 btn btn-xs px-2 light btn-danger"
                    style={{ marginRight: "8px" }}
                    onClick={() => onDeleteBuyer(record?.id)}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 6H5H21"
                        stroke="#fff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                        stroke="#fff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </>
              )}
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <>
      {viewOffer?.cond ? (
        <div className="col-lg-12">
          <div className="card project-card">
            <div class="card-header d-sm-flex d-block">
              <div class="d-flex me-auto mb-sm-0" onClick={onBack}>
                <span
                  style={{ fontSize: "18px" }}
                  className="d-flex justify-content-start align-items-center me-3"
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 class="card-title">{t("hOffdetail")}</h4>
              </div>
            </div>
            <div className="card-body">
              {/* Offer Details */}
              <div className="d-flex mb-4 align-items-start">
                <div className="me-auto">
                  <h5 className="title font-w600 mb-2">{t("hOffdetail")}</h5>
                </div>
                <div className="d-flex align-items-start">
                  {ctxObj?.loggedinprofiletype === "sellerprofile" &&
                    viewOffer?.data?.status === "pending" && (
                      <div className="me-4">
                        <button
                          type="button"
                          style={{
                            height: "32px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }}
                          className="btn btn-success me-3"
                          onClick={onAcceptOffer}
                        >
                          {t("hAccept")}
                        </button>
                        <button
                          type="button"
                          style={{
                            height: "32px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }}
                          className="btn btn-danger"
                          onClick={onRejectOffer}
                        >
                          {t("hReject")}
                        </button>
                      </div>
                    )}
                  {/* {viewOffer?.data?.status === "accepted" && (
                        <div className="me-4">
                            <button
                                type="button"
                                style={{ height: '32px', paddingTop: '0px', paddingBottom: '0px' }}
                                className="btn btn-primary"
                                onClick={() => onCreateContract(viewOffer?.data?.business?.id)}>
                                Create Contract
                            </button>
                        </div>
                     )} 
                    */}
                  <span
                    class={`badge d-sm-inline-block d-none ${getStatusBadge(
                      viewOffer?.data?.status
                    )}`}
                  >
                    {viewOffer?.data?.status}
                  </span>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-sm-6 mb-sm-0 mb-3">
                  <p>
                    {t("hprice")}: {viewOffer?.data?.price}
                  </p>
                  <p>
                    {t("currencyInput")}:{" "}
                    {viewOffer?.data?.business?.currency?.code}(
                    {viewOffer?.data?.business?.currency?.symbol})
                  </p>
                </div>
                <div className="col-sm-6 mb-sm-0 mb-3">
                  <p>
                    {t("businessEquityOffered")}:{" "}
                    {viewOffer?.data?.equityoffered}
                  </p>
                  <p>
                    {t("hmessage")}: {viewOffer?.data?.message}
                  </p>
                </div>
              </div>

              <hr />

              {/* Business Details */}
              <div className="d-flex mb-1 align-items-start">
                <div className="me-auto">
                  <h5 className="title font-w600 mb-2">
                    {t("businessDetailsTitle")}
                  </h5>
                </div>
                <span
                  class={`badge d-sm-inline-block d-none ${getStatusBadge(
                    viewOffer?.data?.business?.status
                  )}`}
                >
                  {viewOffer?.data?.business?.status}
                </span>
              </div>

              <div className="row mb-1">
                <div className="col-sm-6 mb-sm-0 mb-3">
                  <p>
                    {t("nameInput")}: {viewOffer?.data?.business?.name}
                  </p>
                  <p>
                    {t("signUpEmailInput")}:{" "}
                    {viewOffer?.data?.business?.contact_email}
                  </p>
                  <p>
                    {t("secondaryEmailInput")}:{" "}
                    {viewOffer?.data?.business?.email}
                  </p>
                  <p>
                    {t("phoneInput")}: {viewOffer?.data?.business?.phone}
                  </p>
                  <p>
                    {t("phoneInput")}2: {viewOffer?.data?.business?.phone2}
                  </p>
                  <p>Fax: {viewOffer?.data?.business?.fax}</p>
                  <p>
                    {t("currencyInput")}:
                    {viewOffer?.data?.business?.currency?.code}(
                    {viewOffer?.data?.business?.currency?.symbol})
                  </p>
                </div>
                <div className="col-sm-6 mb-sm-0 mb-3">
                  <p>
                    {t("signUpAddressInput")}:{" "}
                    {viewOffer?.data?.business?.address}
                  </p>
                  <p>
                    {t("signUpCityInput")}: {viewOffer?.data?.business?.city}
                  </p>
                  <p>
                    {t("signUpCountrynput")}:{" "}
                    {viewOffer?.data?.business?.country}
                  </p>
                  <p>
                    {t("regionInput")}: {viewOffer?.data?.business?.region}
                  </p>
                  <p>
                    {t("postalCodeInput")}:{" "}
                    {viewOffer?.data?.business?.postal_code}
                  </p>
                  <p>
                    {t("descriptionInput")}:{" "}
                    {viewOffer?.data?.business?.description}
                  </p>
                  <p>
                    {t("businessDetailsCreatedDate")}:{" "}
                    {viewOffer?.data?.business?.created_at === ""
                      ? ""
                      : new Date(
                          viewOffer?.data?.business?.created_at
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })}
                  </p>
                </div>
              </div>

              <div className="d-flex flex-wrap align-items-center mb-2">
                <div className="d-flex align-items-center flex-wrap mb-1">
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("askingPriceInput")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.asking_price}
                    </p>
                  </div>
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("assetsValueInput")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.assets_value}
                    </p>
                  </div>
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("equityOfferedInput")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.equity_offered}
                    </p>
                  </div>
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("businessAverageMonthlySales")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.average_monthly_sales}
                    </p>
                  </div>
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("businessYearlySales")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.yearly_sales}
                    </p>
                  </div>
                  <div className="text-center border-bx me-2 mb-2">
                    <span>{t("businessEbitda")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.ebitda}
                    </p>
                  </div>
                  <div className="text-center border-bx mb-2">
                    <span>{t("employeesNumberInput")}</span>
                    <p className="mb-0 pt-1 font-w500 text-black">
                      {viewOffer?.data?.business?.employees_number}
                    </p>
                  </div>
                </div>
              </div>

              {ctxObj?.loggedinprofiletype !== "buyerprofile" && (
                <>
                  <hr />

                  {/* Buyer Details */}
                  <div className="d-flex mb-4 align-items-start">
                    <div className="me-auto">
                      <h5 className="title font-w600 mb-2">
                        {t("buyerDetailsTitle")}
                      </h5>
                    </div>
                    <span
                      class={`badge d-sm-inline-block d-none ${getStatusBadge(
                        viewOffer?.data?.status
                      )}`}
                    >
                      {viewOffer?.data?.status}
                    </span>
                  </div>

                  <div className="row mb-4">
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <p>
                        {t("nameInput")}: {viewOffer?.data?.buyer?.name}
                      </p>
                      <p>
                        {t("signUpEmailInput")}:{" "}
                        {viewOffer?.data?.buyer?.contactemail}
                      </p>
                      <p>
                        {t("secondaryEmailInput")}:{" "}
                        {viewOffer?.data?.buyer?.email}
                      </p>
                      <p>
                        {t("phoneInput")}: {viewOffer?.data?.buyer?.phone}
                      </p>
                      <p>
                        {t("phoneInput")}2: {viewOffer?.data?.buyer?.phone2}
                      </p>
                      <p>Fax: {viewOffer?.data?.buyer?.fax}</p>
                      <p>
                        {t("domainInput")}: {viewOffer?.data?.buyer?.domain}
                      </p>
                    </div>
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <p>
                        {t("signUpAddressInput")}:{" "}
                        {viewOffer?.data?.buyer?.address}
                      </p>
                      <p>
                        {t("signUpCityInput")}: {viewOffer?.data?.buyer?.city}
                      </p>
                      <p>
                        {t("signUpCountrynput")}:{" "}
                        {viewOffer?.data?.buyer?.country}
                      </p>
                      <p>
                        {t("regionInput")}: {viewOffer?.data?.buyer?.region}
                      </p>
                      <p>
                        {t("postalCodeInput")}:{" "}
                        {viewOffer?.data?.buyer?.postalcode}
                      </p>
                      <p>
                        {t("currencyInput")}:{" "}
                        {viewOffer?.data?.buyer?.currency?.name}
                      </p>
                      <p>
                        {t("investmentRangeInput")}:{" "}
                        {viewOffer?.data?.buyer?.investmentrange}
                      </p>
                    </div>
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <h5 className="title font-w600 mb-2">
                        {t("hinteressedIndustrie")}
                      </h5>
                      <div className="d-flex flex-wrap align-items-center w-100">
                        <div className="d-flex align-items-center flex-wrap mb-1">
                          {viewOffer?.data?.buyer?.industries?.length > 0 &&
                            viewOffer?.data?.buyer?.industries.map((item) => (
                              <div
                                key={`businessIndustries${item}`}
                                className="text-center border-bx me-2 mb-2"
                              >
                                <span>{item}</span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <h5 className="title font-w600 mb-2">
                        {t("buyerDetailsInterestedLocations")}
                      </h5>
                      <div className="d-flex flex-wrap align-items-center w-100">
                        <div className="d-flex align-items-center flex-wrap mb-1">
                          {viewOffer?.data?.buyer?.interestedlocations?.length >
                            0 &&
                            viewOffer?.data?.buyer?.interestedlocations.map(
                              (item) => (
                                <div
                                  key={`businessLocations${item}`}
                                  className="text-center border-bx me-2 mb-2"
                                >
                                  <span>{item}</span>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {ctxObj?.loggedinprofiletype !== "sellerprofile" && (
                <>
                  <hr />

                  {/* Seller Details */}
                  <div className="d-flex mb-4 align-items-start">
                    <div className="me-auto">
                      <h5 className="title font-w600 mb-2">
                        {t("sellerDetailsTitle")}
                      </h5>
                    </div>
                    <span
                      class={`badge d-sm-inline-block d-none ${getStatusBadge(
                        viewOffer?.data?.status
                      )}`}
                    >
                      {viewOffer?.data?.status}
                    </span>
                  </div>

                  <div className="row mb-4">
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <p>
                        {t("nameInput")}: {viewOffer?.data?.seller?.name}
                      </p>
                      <p>
                        {t("signUpEmailInput")}:{" "}
                        {viewOffer?.data?.seller?.contactemail}
                      </p>
                      <p>
                        {t("secondaryEmailInput")}:{" "}
                        {viewOffer?.data?.seller?.email}
                      </p>
                      <p>
                        {t("phoneInput")}: {viewOffer?.data?.seller?.phone}
                      </p>
                      <p>
                        {t("phoneInput")}2: {viewOffer?.data?.seller?.phone2}
                      </p>
                      <p>Fax: {viewOffer?.data?.seller?.fax}</p>
                      <p>
                        {t("domainInput")}: {viewOffer?.data?.seller?.domain}
                      </p>
                    </div>
                    <div className="col-sm-6 mb-sm-0 mb-3">
                      <p>
                        {t("signUpAddressInput")}:{" "}
                        {viewOffer?.data?.seller?.address}
                      </p>
                      <p>
                        {t("signUpCityInput")}: {viewOffer?.data?.seller?.city}
                      </p>
                      <p>
                        {t("signUpCountrynput")}:{" "}
                        {viewOffer?.data?.seller?.country}
                      </p>
                      <p>
                        {t("regionInput")}: {viewOffer?.data?.seller?.region}
                      </p>
                      <p>
                        {t("postalCodeInput")}:{" "}
                        {viewOffer?.data?.seller?.postalcode}
                      </p>
                      <p>
                        {t("occupationInput")}:{" "}
                        {viewOffer?.data?.seller?.occupation}
                      </p>
                      <p>
                        {t("websiteInput")}: {viewOffer?.data?.seller?.website}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div class="card">
          <div class="card-header d-sm-flex d-block">
            <div class="d-flex me-auto mb-sm-0">
              <h4 class="card-title">{t("sidebarItemOffers")}</h4>
            </div>
            <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
          </div>

          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={offersData.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        </div>
      )}

      {updateOffer.cond && (
        <AddOfferPopup
          show={updateOffer.cond}
          id={updateOffer.id}
          view={updateOffer.view}
          offerId={updateOffer.offerId}
          onHideOfferModal={() =>
            setUpdateOffer({
              cond: false,
              id: null,
              offerId: null,
              view: false,
            })
          }
          fetchBusinessList={() => {}}
          updateCase={true}
        />
      )}
    </>
  );
}

export default Offers;
